<template>
  <div class="input-group mb-3">
    <div class="input-group-prepend" v-if="prependLabel">
      <span class="input-group-text" style="width: 150px;" v-text="prependLabel"></span>
    </div>
    <input :class="disableInput ? 'form-control-plaintext' : 'form-control'"
      placeholder="0"
      style="max-width: 80px;"
      :value="value"
      :readonly="disableInput"
      @input="$emit('input', $event.target.value)"
    >
    <div class="input-group-append" v-if="appendLabel">
      <span class="input-group-text" v-text="appendLabel"></span>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      value: null,
      prependLabel: {
        default: false,
      },
      appendLabel: {
        default: false,
      },
      disableInput: {
        default: false,
      }
    },
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/js/components/CustomInputGroup.vue